interface InteractionEvent {
    metaKey: boolean;
    altKey: boolean;
    ctrlKey: boolean;
    shiftKey: boolean;
}

export function isModifierEvent(event: InteractionEvent) {
    return Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
